module.exports = __webpack_public_path__ + "img/sv.b91c7d70.svg";